const splitCisloLegMaterialu = (cisloLegMaterialu: string): { type: string, year: number, index: number } => {
  const splittedCisloLegMaterialu = cisloLegMaterialu.split('/');
  const type = splittedCisloLegMaterialu[0];
  const year = Number(splittedCisloLegMaterialu[1]);
  const index = Number(splittedCisloLegMaterialu[2]);

  return {
    type,
    year,
    index,
  };
};

export default splitCisloLegMaterialu;
